/**
 * React Query hook for the unified Live-content roster tab. live_video
 * URL presence is the phase discriminator (nil → live_pending, non-nil
 * → live) — the FE renders a Watch button when the URL is set.
 *
 * No KPI hook here — the Live-content tab doesn't carry a
 * tab-aggregated headline number. The dashboard creator-content card
 * view (a different surface) has its own card pattern.
 */
import { useQuery } from '@tanstack/react-query';

import type { RosterEntryLive } from '@discovr/types';

import {
  createCampaignDetailApi,
  type UnifiedListParams,
} from '../api/campaignQueries';
import type { PagedResult } from '../api/shared';
import { campaignKeys } from '../queryKeys';

const api = createCampaignDetailApi();

/**
 * Paginated Live-content tab list (live_pending + live). `params.status`
 * may narrow to one of the two when the FE exposes sub-tabs.
 */
export function useLiveContentTab(
  campaignId: string,
  params: UnifiedListParams = {},
) {
  return useQuery<PagedResult<RosterEntryLive>>({
    queryKey: campaignKeys.rosterTab(campaignId, 'live-content', params),
    queryFn: () => api.listLiveContent(campaignId, params),
    enabled: !!campaignId,
    staleTime: 30_000,
  });
}
